import Repository from "./Repository";

const GET_PLAYLIST = "/playlist/get";
const GET_ALL_PLAYLIST = "/playlist/getall";
const CREATE_PLAYLIST = "/playlist/create";
const UPDATE_PLAYLIST = "/playlist/update";
const DELETE_PLAYLIST = "/playlist/delete";

const GET_CATEGORY = "/playlist_category/get";
const GET_ALL_CATEGORY = "/playlist_category/getall";
const CREATE_CATEGORY = "/playlist_category/create";
const UPDATE_CATEGORY = "/playlist_category/update";
const DELETE_CATEGORY = "/playlist_category/delete";

const GET_EPISODE = "/episode/get";
const GET_ALL_EPISODE = "/episode/getall";
const CREATE_EPISODE = "/episode/create";
const UPDATE_EPISODE = "/episode/update";
const DELETE_EPISODE = "/episode/delete";

const GET_ALL_HISTORY = "/watchHistory/getall";
const CREATE_HISTORY = "/watchHistory/create";
const UPDATE_HISTORY = "/watchHistory/update";

const GET_ALL_FORM = "/form/getall";
const CREATE_FORM = "/form/create";
const UPDATE_FORM = "/form/update";
const DELETE_FORM = "/form/delete";

export default {
  get_playlist(payload) {
    return Repository.get(transformRoute(GET_PLAYLIST), { params: payload });
  },
  getall_playlist(payload) {
    return Repository.get(transformRoute(GET_ALL_PLAYLIST), {
      params: payload,
    });
  },
  add_playlist(payload) {
    return Repository.post(transformRoute(CREATE_PLAYLIST), payload);
  },
  update_playlist(payload) {
    return Repository.post(transformRoute(UPDATE_PLAYLIST), payload);
  },
  delete_playlist(payload) {
    return Repository.post(transformRoute(DELETE_PLAYLIST), payload);
  },

  //-------//
  get_category(payload) {
    return Repository.get(transformRoute(GET_CATEGORY), { params: payload });
  },
  getall_category(payload) {
    return Repository.get(transformRoute(GET_ALL_CATEGORY), {
      params: payload,
    });
  },
  add_category(payload) {
    return Repository.post(transformRoute(CREATE_CATEGORY), payload);
  },
  update_category(payload) {
    return Repository.post(transformRoute(UPDATE_CATEGORY), payload);
  },
  delete_category(payload) {
    return Repository.post(transformRoute(DELETE_CATEGORY), payload);
  },

  //-------//
  get_episode(payload) {
    return Repository.get(transformRoute(GET_EPISODE), { params: payload });
  },
  getall_episode(payload) {
    return Repository.get(transformRoute(GET_ALL_EPISODE), {
      params: payload,
    });
  },
  add_episode(payload) {
    return Repository.post(transformRoute(CREATE_EPISODE), payload);
  },
  update_episode(payload) {
    return Repository.post(transformRoute(UPDATE_EPISODE), payload);
  },
  delete_episode(payload) {
    return Repository.post(transformRoute(DELETE_EPISODE), payload);
  },

  //-------//
  getall_history(payload) {
    return Repository.get(transformRoute(GET_ALL_HISTORY), {
      params: payload,
    });
  },
  add_history(payload) {
    return Repository.post(transformRoute(CREATE_HISTORY), payload);
  },
  update_history(payload) {
    return Repository.post(transformRoute(UPDATE_HISTORY), payload);
  },

  //-------//
  getall_form(payload) {
    return Repository.get(transformRoute(GET_ALL_FORM), {
      params: payload,
    });
  },
  add_form(payload) {
    return Repository.post(transformRoute(CREATE_FORM), payload);
  },
  update_form(payload) {
    return Repository.post(transformRoute(UPDATE_FORM), payload);
  },
  delete_form(payload) {
    return Repository.post(transformRoute(DELETE_FORM), payload);
  },
};

const transformRoute = (route) => {
  return `/cms${route}`;
};
